class SlickSlider {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Bail out if we do not have the slider
        if ('function' !== typeof $.fn.slick) return;

        // Slideshow options
        $('.single-item.slider > .slideshow').each(function (e) {

            // Declare and initialize
            let speed        = $(this).data('slideshow-autoscroll-speed');
            let adapt        = $(this).data('slideshow-adaptive-height');
            let navContainer = $(this).data('slideshow-nav-container');
            let prevArrow    = $(this).data('slideshow-prev-arrow-label');
            let nextArrow    = $(this).data('slideshow-next-arrow-label');
            let slides       = $(this).data('slideshow-slides-to-show');
            let slideScroll  = $(this).data('slideshow-slides-to-scroll');
            let responsive   = $(this).data('slideshow-responsive');
            let arrowClass   = $(this).data('slideshow-arrow-class');
            let center       = 'on' === $(this).data('slideshow-center-mode');
            let swipe        = 'on' === $(this).data('slideshow-swipe-scroll');
            let notInfinite  = 'on' === $(this).data('slideshow-not-infinite');

            // Set up the initialization args
            let args = {
                autoplay:       true,
                dots:           false,
                autoplaySpeed:  speed || 5000,
                adaptiveHeight: 'on' === adapt,
                lazyLoad:       'progressive',
                slidesToShow:   slides || 1,
                slidesToScroll: slideScroll || 1,
                centerMode:     center,
                swipeToSlide:   swipe,
                responsive:     responsive || {},
                infinite:       !notInfinite,
                prevArrow:      '<button type="button" class="slick-prev'
                                    + (arrowClass ? ' ' + arrowClass : '') + '">'
                                    + (prevArrow || 'Previous') + '</button>',
                nextArrow:      '<button type="button" class="slick-next'
                                    + (arrowClass ? ' ' + arrowClass : '') + '">'
                                    + (nextArrow || 'Next') + '</button>'
            };

            // Try to set the nav container
            if (!!navContainer) {

                // Go way back
                let parent    = $(this).closest('section');
                let container = parent.find(navContainer);

                // Add the nav container
                if (0 < container.length)
                    args.appendArrows = container[0];

            }

            // Initialize the slideshow
            $(this).slick(args);

            // Rerun the height offsetter
            $(document).trigger('ll5RunOffsetHeight');

        });

        $('.single-item.slider > .slide-nav').slick({
            slidesToShow:   5,
            slidesToScroll: 1,
        });

        // Prevent dropdown from closing when clicking inside
        $(document).on('click', '[data-dropdown-focus="on"]', function (e) {

            // Let the closing continue if it was a close button
            if ('on' === $(e.target).data('toggle-close')) return;

            // Otherwise prevent closures
            e.stopPropagation();

        });

        // Prevent click on the slide from doing anything
        $('.slide-nav').on('click', 'a', function (e) {

            e.preventDefault();

        });

        // Allow changing of slideshow when clicked
        $('.slideshow-has-nav').on('click', '.slide-nav', function (e) {

            e.preventDefault();

            // Declare and initialize
            let selector = $(this).data().slick.asNavFor;
            let target   = $(selector);
            let item     = $(e.target).closest('.slick-slide');
            let index    = item.data('slick-index');

            // Bail out if there is no target
            if (!target.length) return;

            // Move the target slider
            target.slick('slickGoTo', index)

        });

        // Instantiate our lightbox
        if ($.isFunction($.fn.slickLightbox))
            $('.slideshow-lightbox').slickLightbox({
                itemSelector: 'a'
            });

    }
}

export default SlickSlider;